import React from "react";

// Mui Styles
import { StyledPaper } from "../styles/mui/globalStyles";

// Mui
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "../components/layout";
import Title from "../components/title";
import TransferInvoiceDataRow from "../components/transferInvoiceDataRow";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import { getTransferInvoiceById } from "../fetch/fetchStock";

import _ from "lodash";

const TransferInvoiceByIdPage = (props) => {
  const { open, setOpen } = props;

  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [selectedShop, setSelectedShop] = React.useState(0);

  const [rowsData, setRowsData] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  // Fetch
  const fetchAll = async () => {
    await getTransferInvoiceById(id).then((data) => {
      if (data && data.results) setRowsData(data.data);
    });
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setRowsData([]);
    setIsLoading(true);
    // fetchCustomerDaily();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedShop]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={24}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`調貨清單/詳細`} history={() => navigate(-1)} />

      <StyledPaper page={"yes"} alignItems={"left"}>
        <Grid container spacing={2}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>員工名稱</TableCell>

                  <TableCell>調貨貨品</TableCell>

                  <TableCell>數量</TableCell>

                  <TableCell>調出</TableCell>
                  <TableCell></TableCell>

                  <TableCell>調進</TableCell>
                  <TableCell>調貨原因</TableCell>
                  <TableCell>備註 </TableCell>

                  <TableCell>調貨時間</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              {!_.isEmpty(rowsData) ? (
                <TransferInvoiceDataRow
                  data={rowsData}
                  // handleChecked={handleChecked}
                />
              ) : _.isEmpty(rowsData) <= 0 && isLoading === false ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      沒有資料
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Grid>
      </StyledPaper>
    </Layout>
  );
};

export default TransferInvoiceByIdPage;
